<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="clientSchools"
    sort-by="effectiveDate"
    sort-desc
    group-by="semester.semesterId"
    group-desc
  >
    <template
      v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
    >
      <td :colspan="headers.length">
        <v-btn @click="toggle" x-small icon :ref="group">
          <v-icon v-if="isOpen">mdi-minus</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
        <span class="mx-5 font-weight-bold" style="font-size: 14px">{{
          items[0].semester.semesterCode
        }}</span>
      </td>
    </template>
    <template v-slot:[`item.client.fullName`]="{ item }">
      <span
        style="cursor: pointer"
        class="text-decoration-underline indigo--text"
        @click="goToClient(item.clientId)"
        >{{ item.client.fullName }}</span
      ></template
    >
  </v-data-table>
</template>

<script>
export default {
  props: ["schoolId"],
  data() {
    return {
      loading: false,
      clientSchools: [],
      headers: [
        { text: "Client", value: "client.fullName" },
        { text: "Semester", value: "semester.semesterCode" },
        { text: "Effective Date", value: "formattedEffectiveDate" },
        { text: "End Date", value: "formattedEndDate" },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    this.clientSchools = await this.$store.dispatch(
      "clientModule/getRegistrationsForSchool",
      this.schoolId
    );
    this.loading = false;
  },
  methods: {
    goToClient(clientId) {
      this.$router.push({
        name: "ClientDetails",
        params: { clientId: clientId },
      });
    },
  },
};
</script>